export default __webpack_public_path__ + "static/media/Guru-brahma.fab47015.mp3";